import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontFamily: "Poppins",
    fontSize: "14px",
  },
  divContainer: {
    display: "flex",
    gap: "24px",
  },
  innerLeftContainer: {
    display: "flex",
    gap: "12px",
  },
  manageReviewBtn: {
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "10px",
    width: "183px",
    height: "46px",
  },
  addReviewBtn: {
    backgroundColor: theme.palette.secondary.main,
    height: "46px",
    width: "auto",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "12px",
    color: theme.palette.text.secondary,
  },
  divider: {
    background: "#606479",
    marginTop: "12px",
  },
  heading: {
    margin: "0px",
    fontSize: "24px",
    color: theme.palette.text.tertiary,
  },
  reviewVersionStatusFiltersContainer: {
    backgroundColor: "#252A38",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    cursor: "default",
    gap: "12px",
  },
  backButton: {
    color: theme.palette.secondary.main,
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "5px",
    padding: "5px 10px",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px",
    },
    "&:hover": {
      color: theme.palette.secondary.main,
      backgroundColor: "transparent",
    },
  },
}));

export default useStyles;
